
import React from "react";
import { Client } from "../types";
import { CardContent } from "@/components/ui/card";
import { ClientInfo } from "./ClientInfo";
import { TeamAssignment } from "./TeamAssignment";
import { ClientTeams as ClientTeamsView } from "./ClientTeams";
import { ClientSchedules } from "./ClientSchedules";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Calendar, Info, Users, ClipboardList, Building } from "lucide-react";

interface ClientExpandedInfoProps {
  client: Client;
  onClientUpdated?: () => void;
}

export const ClientExpandedInfo: React.FC<ClientExpandedInfoProps> = ({
  client,
  onClientUpdated = () => {} // Provide a default empty function
}) => {
  return (
    <CardContent className="pt-0">
      <Tabs defaultValue="info">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="info" className="flex items-center gap-2">
            <Info className="h-4 w-4" />
            <span>Info</span>
          </TabsTrigger>
          <TabsTrigger value="teams" className="flex items-center gap-2">
            <Users className="h-4 w-4" />
            <span>Teams</span>
          </TabsTrigger>
          <TabsTrigger value="assignments" className="flex items-center gap-2">
            <ClipboardList className="h-4 w-4" />
            <span>Assignments</span>
          </TabsTrigger>
          <TabsTrigger value="schedule" className="flex items-center gap-2">
            <Calendar className="h-4 w-4" />
            <span>Schedule</span>
          </TabsTrigger>
          <TabsTrigger value="facility" className="flex items-center gap-2">
            <Building className="h-4 w-4" />
            <span>Facility Presence</span>
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="info">
          <ClientInfo client={client} />
        </TabsContent>
        
        <TabsContent value="teams">
          <TeamAssignment clientId={client.id} displayOnly />
        </TabsContent>
        
        <TabsContent value="assignments">
          <ClientTeamsView clientId={client.id} />
        </TabsContent>
        
        <TabsContent value="schedule">
          <ClientSchedules clientId={client.id} />
        </TabsContent>
        
        <TabsContent value="facility">
          <div className="h-[800px] w-full">
            <iframe
              src="https://www.facility.shiftask.app"
              className="h-full w-full border rounded-lg"
              title="Facility Presence"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              sandbox="allow-same-origin allow-scripts allow-forms allow-navigation"
            />
          </div>
        </TabsContent>
      </Tabs>
    </CardContent>
  );
};
